<template>
  <div>
    <!-- 创意磁贴 -->
    <div v-if="formKey === 'plugin_ids'">
      <div class="flex items-center">
        <el-button v-if="!formItem.isPreview" type="primary" @click="openPluginIds(formItem)">选择磁贴组件</el-button>
        <i v-if="Object.keys(formItem.value || {}).length && !formItem.isPreview" class="el-icon-success app-check-icon-success ml-10" />
      </div>
      <div v-if="formItem.isPreview">
        <div v-if="getPluginIdsList(formItem).length">
          <div v-for="(item, key) in getPluginIdsList(formItem)" :key="key">
            <span class="mr-20">{{ item.advertiser_id }}</span>
            <span class="mr-20">{{ item.name }}</span>
          </div>
        </div>
        <div v-else>-</div>
      </div>
      <el-dialog
        title="创意磁贴配置"
        :visible.sync="formItem.is_open"
        :close-on-click-modal="false"
        :append-to-body="true"
        :modal-append-to-body="true"
        width="1000px"
      >
        <plugin-ids v-if="formItem.is_open" :form-item="formItem" :init-ops="initOps" />
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="formItem.is_open = false">取 消</el-button>
          <el-button size="mini" type="primary" @click="confirmPluginIds(formItem)">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { component_props } from '@/views/fusion/investment/intelligence-create/components/main-view/components/step-form/model/props';
import { data_sharing_mixin } from '@/views/fusion/investment/intelligence-create/mixins/data-sharing';

export default {
  components: {
    'plugin-ids': () => import('./components/plugin-ids/index.vue'),
  },
  mixins: [data_sharing_mixin],
  props: {
    ...component_props,
  },
  methods: {
    /**
     * 根据值获取选项
     * @param {Object[]} options 选项
     * @param {number|string} val 值
     * @returns {Object}
     */
    getPluginIdsList(form_item) {
      const list = [];
      const value = form_item.value || {};
      Object.entries(value).filter(([, v]) => v.length).forEach(([advertiser_id, v]) => {
        v.forEach(({ name }) => {
          list.push({ advertiser_id, name });
        });
      });
      return list;
    },
    /**
     * 打开组件配置
     * @param form_item 表单项
     * @returns {void}
     */
    openPluginIds(form_item) {
      form_item.assignSelection = JSON.parse(JSON.stringify(form_item.value));
      form_item.is_open = true;
    },
    /**
     * 组件配置弹窗确认
     * @param form_item 表单项
     * @returns {void}
     */
    confirmPluginIds(form_item) {
      const result = JSON.parse(JSON.stringify(form_item.assignSelection));
      form_item.value = result;
      form_item.is_open = false;
      form_item?.on?.change?.(form_item.value);
    },
  },
};
</script>
